import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5 1.67a5 5 0 1 1-7.498 4.492L1 6l.002-.162A5 5 0 0 1 8.5 1.67M6 3a.5.5 0 0 0-.497.441L5.5 3.5V6l.005.065a.5.5 0 0 0 .098.239l.043.05 1.5 1.5.048.04a.5.5 0 0 0 .612 0l.048-.04.041-.048a.5.5 0 0 0 0-.613l-.041-.047L6.5 5.792V3.5l-.003-.059A.5.5 0 0 0 6 3"
    }, null, -1)
  ])))
}
export default { render: render }